module.exports = __webpack_public_path__ + "img/bgfw2.7df4eb5b.png";